import { render } from "./deleteModule.vue?vue&type=template&id=1c7bf2b7"
import script from "./deleteModule.vue?vue&type=script&lang=js"
export * from "./deleteModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__